//  Copyright (c) 2019-2025 Cigent Technology Inc. All Rights Reserved.
import { Component, OnInit } from '@angular/core';
import { IUser } from '../../../types/user';
import { IGroup } from '../../../types/group';
import { UserService } from '../../../services/user-service';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from '../../../services/notification-service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-move-user-dialog',
    templateUrl: './re-parent-user-dialog.component.html',
    styleUrls: ['./re-parent-user-dialog.component.scss'],
    standalone: false
})
export class ReParentUserDialogComponent implements OnInit {
  users: IUser[] = [];
  groups: IGroup[] = [];
  selectedGroup: IGroup = null;
  selectedUser: IUser = null;

  constructor(public dialogRef: MatDialogRef<ReParentUserDialogComponent>,
              private userService: UserService,
              private notification: NotificationService,
              private translate: TranslateService) { }

  ngOnInit() {
    this.userService.api_get_all_users().subscribe(users => {
      this.users = users.sort( (u1, u2) => {
        const name1 = u1.username.toLocaleLowerCase();
        const name2 = u2.username.toLocaleLowerCase();
        if ( name1 > name2 ) {
          return 1;
        } else if ( name1 < name2 ) {
          return -1;
        }
        return 0;
      });
    });
    this.userService.api_groups().subscribe(groups => {
      this.groups = groups.sort( (g1, g2) => {
        const groupName1 = g1.name.toLocaleLowerCase();
        const groupName2 = g2.name.toLocaleLowerCase();
        if ( groupName1 > groupName2 ) {
          return 1;
        } else if ( groupName1 < groupName2 ) {
          return -1;
        }
        return 0;
      });
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSubmit() {
    if ( this.selectedUser != null || this.selectedGroup != null ) {
      this.userService.reParentUser(this.selectedUser.id, this.selectedGroup.id).subscribe(
          {
              next: (result) => {
                this.notification.showSuccess(this.translate.instant('SUCCESS'));
                this.dialogRef.close(result);
              },
              error: () => this.notification.showError(this.translate.instant('REPORT_SAVE_ERROR'))
          }
      );
    }
  }
}
